// extracted by mini-css-extract-plugin
module.exports = {"boxShadow":"styles_boxShadow__393JF","displayHeight":"styles_displayHeight__yNEst"};